// =============================================================================
// components/ui/index.js — registro global de componentes UI normalizados
// -----------------------------------------------------------------------------
// Disponibles en CUALQUIER SFC sin importar nada:
//   <UiButton variant="primary" type="submit" :loading="isSaving">Guardar</UiButton>
//   <UiInput v-model="form.name" label="Nombre" required :icon="User" />
//   <UiSelect v-model="form.gender" :options="[{value:'M', label:'MASCULINO'}]" />
//   <UiSelect v-model="form.activity" :options="activities" filterable placeholder="Buscar actividad..."/>
//   <UiModal :show="show" title="Nuevo Usuario" size="3xl" @close="show = false">
//     <template #toolbar><UiTabs v-model="activeTab" :items="tabs" /></template>
//     <p>Contenido del modal...</p>
//     <template #footer><UiButton @click="save">Guardar</UiButton></template>
//   </UiModal>
//   <UiTable :columns="columns" :rows="filteredList" :page-size="10" caption="Listado de clientes">
//     <template #cell-status="{ row }"><span class="badge">{{ row.status }}</span></template>
//   </UiTable>
//   <UiFileUpload v-model="form.document_front_url" label="Documento Frente" accept="image/*"
//     :max-size="2 * 1024 * 1024" :loading="isUploadingFront"
//     @files-selected="(files) => handleImageUpload(files[0], 'document_front_url')" />
//   <UiTabs v-model="activeTab" :items="[{ value: 'general', label: 'Perfil General', icon: Building2 }]" />
// =============================================================================
import UiButton from './UiButton.vue';
import UiInput from './UiInput.vue';
import UiSelect from './UiSelect.vue';
import UiTable from './UiTable.vue';
import UiTextarea from './UiTextarea.vue';
import UiModal from './UiModal.vue';
import UiFileUpload from './UiFileUpload.vue';
import UiTabs from './UiTabs.vue';

export const uiComponents = [
  { name: 'UiButton', component: UiButton },
  { name: 'UiInput', component: UiInput },
  { name: 'UiSelect', component: UiSelect },
  { name: 'UiTable', component: UiTable },
  { name: 'UiTextarea', component: UiTextarea },
  { name: 'UiModal', component: UiModal },
  { name: 'UiFileUpload', component: UiFileUpload },
  { name: 'UiTabs', component: UiTabs },
];

/** Registra todos los componentes UI como globales en la app. */
export function registerUiComponents(app) {
  uiComponents.forEach(({ name, component }) => app.component(name, component));
}